exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".s-container[data-v-5267855c]{width:100%}", ""]);

// exports
